<p-autoComplete panelStyleClass="email-recipients" autocomplete="true" [formControl]="control" dataKey="_id" field="email" unique="true" [suggestions]="data$ | async" (completeMethod)="onFindRecipients($event.query)" [multiple]="true" [placeholder]="placeholder" appendTo="body">
    <ng-template let-item pTemplate="recipients">

        <div class="recipient">
            <profile class="user" [userId]="$safeNavigationMigration(item?._id)" [userName]="$safeNavigationMigration(item?.name)"></profile>
            <div class="recipient-details">
                <div class="name">{{item?.name}}</div>
                <div class="email" *ngIf="item?.email">{{item?.email}}</div>
            </div>
        </div>

    </ng-template>

    <ng-template let-value pTemplate="selectedItem">
        <div class="mr-20" [title]="$safeNavigationMigration(value?.name)">{{value?.email}}</div>
    </ng-template>
</p-autoComplete>